// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.load()
  }

  load() {
    fetch(this.urlValue, {headers: {accept: 'text/html'}})
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html;
        //this.element.textContent = html;
        //this.element.innerText = html;
        init_select2();
        liveSearch();
      })
  }
}
